import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import logo from '../../constants/mrf-logo'
import { SITE_NAME, SITE_DESCRIPTION } from '../../constants/site-info'
import { canonicalUrl, absoluteImage, summarize, serializeSchema } from '../../utils/seo'

export default function Seo({ title = SITE_NAME, description = SITE_DESCRIPTION, path = '/', image = logo, socialImage, type = 'website', noIndex = false, structuredData }) {
  const { site } = useStaticQuery(graphql`query MRFSeoSettings { site { siteMetadata { isStaging } } }`)
  const url = canonicalUrl(path)
  const imageUrl = absoluteImage(socialImage && socialImage.url) || absoluteImage(image) || absoluteImage(logo)
  const blocked = noIndex || site.siteMetadata.isStaging || /^\/(gestisci-consensi|404|dev-404-page)(\/|\.|$)/.test(path)
  const pageTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME} (MRF)`
  const summary = summarize(description, 190)
  return <Helmet htmlAttributes={{ lang: 'it' }} title={pageTitle}>
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <link rel="manifest" href="/site.webmanifest" />
    <link rel="alternate" type="application/rss+xml" title="Aggiornamenti MRF" href="https://www.movimentorivoluzionefiscale.it/feed.xml" />
    <meta name="description" content={summary} />
    <link rel="canonical" href={url} />
    <meta name="robots" content={blocked ? 'noindex,follow' : 'index,follow,max-image-preview:large'} />
    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:locale" content="it_IT" />
    <meta property="og:type" content={type} />
    <meta property="og:url" content={url} />
    <meta property="og:title" content={pageTitle} />
    <meta property="og:description" content={summary} />
    <meta property="og:image" content={imageUrl} />
    {socialImage && <meta property="og:image:secure_url" content={imageUrl} />}
    {socialImage && <meta property="og:image:width" content={String(socialImage.width)} />}
    {socialImage && <meta property="og:image:height" content={String(socialImage.height)} />}
    {socialImage && <meta property="og:image:type" content={socialImage.type} />}
    {socialImage && <meta property="og:image:alt" content={socialImage.alt} />}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={pageTitle} />
    <meta name="twitter:description" content={summary} />
    <meta name="twitter:image" content={imageUrl} />
    {socialImage && <meta name="twitter:image:alt" content={socialImage.alt} />}
    {structuredData && <script type="application/ld+json">{serializeSchema(structuredData)}</script>}
  </Helmet>
}
